import React from "react";

export const MagnifierLogo = () => {
  return (
    <svg
    width="26"
    height="26"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_105_46)">
        <mask
          id="mask0_105_46"
          maskUnits="userSpaceOnUse"
          x="0"
          y="-1"
          width="20"
          height="20"
        >
          <rect
            x="0.999756"
            y="-0.000366211"
            width="19"
            height="19"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_105_46)">
          <path
            d="M16.0612 15.8726L11.4893 11.3205C11.0935 11.6503 10.6383 11.9076 10.1237 12.0923C9.60911 12.2771 9.08134 12.3694 8.54036 12.3694C7.18134 12.3694 6.03342 11.901 5.09661 10.9642C4.15981 10.0274 3.69141 8.8795 3.69141 7.52047C3.69141 6.17463 4.15981 5.02988 5.09661 4.08622C6.03342 3.14308 7.18134 2.67151 8.54036 2.67151C9.8862 2.67151 11.0275 3.13991 11.9643 4.07672C12.9011 5.01352 13.3695 6.16144 13.3695 7.52047C13.3695 8.08783 13.2772 8.6288 13.0924 9.14338C12.9077 9.65797 12.657 10.1066 12.3404 10.4892L16.9122 15.0611C17.0178 15.1666 17.0706 15.2986 17.0706 15.4569C17.0706 15.6153 17.0112 15.7538 16.8924 15.8726C16.7737 15.9913 16.632 16.0507 16.4673 16.0507C16.3021 16.0507 16.1668 15.9913 16.0612 15.8726ZM8.54036 11.1819C9.55634 11.1819 10.4174 10.8257 11.1236 10.1132C11.8292 9.40068 12.182 8.53644 12.182 7.52047C12.182 6.50449 11.8292 5.64026 11.1236 4.92776C10.4174 4.21526 9.55634 3.85901 8.54036 3.85901C7.5112 3.85901 6.6438 4.21526 5.93816 4.92776C5.23199 5.64026 4.87891 6.50449 4.87891 7.52047C4.87891 8.53644 5.23199 9.40068 5.93816 10.1132C6.6438 10.8257 7.5112 11.1819 8.54036 11.1819Z"
            fill="#D3D3D3"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_105_46">
          <rect
            width="18.8973"
            height="18.8973"
            fill="white"
            transform="translate(0.897217 0.0513916)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MagnifierLogo;
